import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LoginComponent } from './login.component';
import { AngularLoginModule, AngularAlertModule, AngularComboModule } from 'angular-library';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [SharedModule, AngularLoginModule, ReactiveFormsModule, AngularAlertModule, AngularComboModule ],
    declarations: [LoginComponent],
    exports: [],
    providers: []
})
export class LoginModule { }


// WEBPACK FOOTER //
// ./src/app/login/login.module.ts